import React from 'react'
import {Actions, TabPanel} from './ProductCatalogProposalTab.styles'
import {Button} from '../../../../../../core/shared/Button'
import {TabGroup} from '../TabGroup'
import Icon from '../../../../../../core/shared/Icon'
import {useProposalOptions} from '../../hooks/useProposalOptions'

// ── Component ─────────────────────────────────────────────────────────────────

export default function ProductCatalogProposalTab() {
  const {
    proposalOptiontabs,
    activeOption,

    setActiveOption,

    handleAddOption,
    handleDuplicateOption,
    handleDeleteOption,
    handleRenameOption,

    canAddMore,
    canDelete,
  } = useProposalOptions()

  return (
    <TabPanel>
      <TabGroup
        tabs={proposalOptiontabs}
        activeTabId={activeOption?.displayOrder}
        onTabSelect={setActiveOption}
        onTabRename={handleRenameOption}
        onTabCopy={handleDuplicateOption}
        onTabDelete={handleDeleteOption}
        canCopy={canAddMore}
        canDelete={canDelete}
      />

      <Actions>
        <Button
          size="sm"
          variant="primary-gray"
          disabled={!canAddMore}
          onClick={handleAddOption}
        >
          <Icon name="add" size="xs" color="#000000" />
          <span>Add Proposal</span>
        </Button>
      </Actions>
    </TabPanel>
  )
}
